/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../../theme/theme"
import { css } from "@mui/material"
import { Button, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { MyText } from "../../../components/text/MyText"
import { AutoSaveInfo } from "../AutoSaveInfo"
import { mobileCss } from "../../../util/isMobile"

interface IntroductionStepProps {
    onStart?: () => void
}

const IntroStepStyle = withMyTheme((theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
    
    ${mobileCss(`
        gap: 1.5rem;
        max-width: 90vw;
    `)}
`)

const ExcitingTitleStyle = withMyTheme((theme) => css`
    font-size: 1.4rem;
    font-weight: 700;
    color: ${theme.palette.primary.main};
    margin-bottom: 0.5rem;
    line-height: 1.3;
    
    ${mobileCss(`
        font-size: 1.2rem;
    `)}
`)

const DescriptionStyle = withMyTheme((theme) => css`
    font-size: 1.1rem;
    color: ${theme.palette.text.primary};
    line-height: 1.5;
    margin-bottom: 1rem;
    
    ${mobileCss(`
        font-size: 1rem;
    `)}
`)

const StartButtonStyle = withMyTheme((theme) => css`
    background-color: ${theme.palette.primary.main};
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 12px 32px;
    border-radius: 25px;
    text-transform: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    
    &:hover {
        background-color: ${theme.palette.primary.dark};
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
    
    ${mobileCss(`
        font-size: 1rem;
        padding: 10px 24px;
    `)}
`)

export const IntroductionStep = ({ onStart }: IntroductionStepProps) => {
    const { t } = useTranslation()
    
    return (
        <div css={IntroStepStyle}>
            <Typography css={ExcitingTitleStyle}>
                {t('questionnaire.intro.excitingTitle')}
            </Typography>
            
            <MyText 
                text={t('questionnaire.intro.description')}
                additionalCss={DescriptionStyle}
            />
            
            <AutoSaveInfo />
            
            <Button 
                css={StartButtonStyle}
                onClick={onStart}
                variant="contained"
                size="large"
                disabled={!onStart}
            >
                Start
            </Button>
        </div>
    )
}